import React from 'react';
import axios from 'axios';
import { useClinicians, CLINICIAN_ROLE_LABEL } from '../../hooks/useClinicians';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function TestedBySelect({ sessionId, value, onChange }) {
  const clinicians = useClinicians();
  const options = value?.id && !clinicians.some((c) => c.user_id === value.id)
    ? [{ user_id: value.id, name: value.name }, ...clinicians]
    : clinicians;

  const pick = async (e) => {
    const id = e.target.value;
    try {
      const r = await axios.put(`${API}/sessions/${sessionId}`, { audiologist_user_id: id });
      onChange({ id, name: r.data?.audiologist_name || options.find((c) => c.user_id === id)?.name });
    } catch (err) {
      window.alert(err?.response?.data?.detail || 'Could not change the tester');
    }
  };

  return (
    <label className="flex items-center gap-1 text-[10px] text-amber-900 font-semibold" data-testid="test-tested-by">
      Tested by
      <select value={value?.id || ''} onChange={pick} data-testid="test-tested-by-select"
        className="text-[11px] border border-amber-300 rounded px-1 py-0.5 bg-white text-slate-800 font-normal">
        {options.map((c) => (
          <option key={c.user_id} value={c.user_id}>
            {c.name}{CLINICIAN_ROLE_LABEL[c.role] ? ` — ${CLINICIAN_ROLE_LABEL[c.role]}` : ''}
          </option>
        ))}
      </select>
    </label>
  );
}
